import { render, staticRenderFns } from "./editSystemVision.vue?vue&type=template&id=2847a791&scoped=true&"
import script from "./editSystemVision.vue?vue&type=script&lang=js&"
export * from "./editSystemVision.vue?vue&type=script&lang=js&"
import style0 from "./editSystemVision.vue?vue&type=style&index=0&id=2847a791&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847a791",
  null
  
)

export default component.exports